import { GET_SALES_SITES,GET_COMMERTIAL_LEAD_DETAILS,GET_SALES_INCENTIVE,
    GET_BENEFICIARY_SENIOR,GET_INCENTIVE_DATA,GET_FINANCE_INCENTIVE_LIST,GET_USER_SENIOR_INCENTIVES } from "./type";

const initialState = {
  incentiveList: [],
  commertialDetails: [],
  getIncentives: [],
  getBeneficiarySenior: [],
  getEditIncentiveData: [],
  getIncentiveListForFinance: [],
  getUserSeniorIncentives: [],
};

const SalesIncentiveReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_SALES_SITES:
      return {
        ...state,
        incentiveList: payload,
      }; 
      case GET_COMMERTIAL_LEAD_DETAILS:
      return {
        ...state,
        commertialDetails: payload,
      }; 
      case GET_SALES_INCENTIVE:
      return {
        ...state,
        getIncentives: payload,
      }; 
      case GET_BENEFICIARY_SENIOR:
      return {
        ...state,
        getBeneficiarySenior: payload,
      };
      case GET_INCENTIVE_DATA:
      return {
        ...state,
        getEditIncentiveData: payload,
      };
      case GET_FINANCE_INCENTIVE_LIST:
      return {
        ...state,
        getIncentiveListForFinance: payload,
      };
      case GET_USER_SENIOR_INCENTIVES:
      return {
        ...state,
        getUserSeniorIncentives: payload,
      };    
    default:
      return {
        ...state,
      };
  }
};

export default SalesIncentiveReducer;
